import { makeExecutableSchema } from 'graphql-tools';
import typeDefs from './typeDefs';
import resolvers from './resolvers';

export { default as typeDefs } from './typeDefs';
export { default as resolvers } from './resolvers';

export default makeExecutableSchema({
  typeDefs,
  resolvers,
});
